export function randomId(text='id-') {
  return text + (Math.round(Math.random() * 100000))
}

// get a random int between 2 int inclusive
export function randomIntFromInterval(min = 0, max = 2) { return Math.floor(Math.random() * (max - min + 1) + min); }

export function generateUID(length = 8) {
  return [...crypto.getRandomValues(new Uint8Array(length))]
    .map((x) => x.toString(36))
    .join('');
}